const xhr = require('xhr');

export default () => {

    const searchButton = document.querySelector('[data-search-icon]');
    const search = document.querySelectorAll('[data-search-form]');

    const initSearch = (dom) => {

    }

    if (search.length) {

        if (searchButton) {
            searchButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (search[0].classList.contains('active')) {
                    search[0].classList.remove('active');
                } else {
                    search[0].classList.add('active');
                }
                return false;
            });
        }

        for (const dom of search) {
            dom.addEventListener('submit', (e) => {
                e.preventDefault();
                const keywords = dom.querySelector('input[type="text"]').value;
                if (!keywords) {
                    return false;
                }

                const searchResults = document.querySelector('[data-search-icon]');
                if (searchResults) {
                    searchResults.remove();
                }

                xhr.get(
                    dom.getAttribute('action') + '?Search=' + keywords,
                    (err, data) => {
                        const t = document.createElement('template');
                        t.innerHTML = data.body;
                        document.querySelector('body').append(t.content);

                        const exit = document.querySelector('[data-search-exit]');
                        exit.addEventListener('click', (e) => {
                            e.preventDefault();
                            document
                                .querySelector('[data-search]')
                                .remove();
                            return false;
                        });

                    }
                );

                return false;
            });
        }
    }

}
